export function setgetTestimonies(data) {
    return {type: "GET_TESTIMONIES", payload:data};
}